export const getPersonShortName = (fullName: string): string => {
  const nameParts = fullName.trim().split(/\s+/);
  
  if (nameParts.length >= 4) {
    return `${nameParts[0]} ${nameParts[nameParts.length - 2]}`;
  } else if (nameParts.length === 3) {
    return `${nameParts[0]} ${nameParts[1]}`;
  } else {
    return nameParts.join(' ');
  }
};